
	import NavBar from "@/components/NavBar.vue";
	import { defineComponent, onMounted } from "vue";
	import DashboardDoctor from "@/components/DashboardDoctor.vue";
	import DashboardPatient from "@/components/DashboardPatient.vue";
	import useUser from "@/store/UserState";
	import { UserType } from "@/domain/entities/UserTypes";
	import FullscreenLoadingIndicator from "@/components/FullscreenLoadingIndicator.vue";

	export default defineComponent({
		name: "Dashboard",

		components: {
			NavBar,
			DashboardPatient, DashboardDoctor, FullscreenLoadingIndicator
		},

		setup() {
			// const authState = useAuth();
			const { user, fetchUserData } = useUser();

			onMounted(async () => {
				await fetchUserData()
			});

			return {
				user,
				UserType,
			};
		},
	});
